export default __webpack_public_path__ + "static/media/video-player.ea03bfd0.svg";